import { Link } from "react-router-dom"
import { ArrowLeft } from "lucide-react"

interface BackLinkProps {
  readonly className?: string
}

/** Link back to the home page, shared by every page below it. */
export function BackLink({ className = "" }: BackLinkProps) {
  return (
    <Link
      to="/"
      className={`inline-flex items-center gap-1.5 text-body-sm text-fg-faint transition-colors hover:text-fg-body ${className}`}
    >
      <ArrowLeft className="size-3 rtl:-scale-x-100" />
      Back to home
    </Link>
  )
}
